import {createValidationForSchema} from '../../utils/ajvValidation'
import {validate as powtoonValidate} from '../../utils/powtoonValidation'
import schema from './schema/01.11.schema.json'
import {isDecimalInteger} from 'powtoon-commons/utils/numbers'
import {applyFunctionOnAllLeafs, DEFAULT_RICH_TEXT_COLOR} from 'powtoon-commons/richText/utils'
import {colord, getFormat} from 'colord'

let ajvValidate = null

export function initValidate ()  {
  if (!ajvValidate){
    ajvValidate = createValidationForSchema(schema)
  }
}

export const validate = async (powtoon,
  {
    strictMode = false,
    ignoreManifest = false,
    isValidTime = isDecimalInteger,
    getMinTimeStep,
    ignoreRichText = false
  } = {}) => {
  const powtoonValidationErrors = powtoonValidate(powtoon, {
    strictMode, ignoreManifest, isValidTime, getMinTimeStep, ignoreRichText
  })

  let powtoonForAjv = powtoon
  if (ignoreManifest) {
    powtoonForAjv = {...powtoon}
    delete(powtoonForAjv.manifest)
  }
  if (!ajvValidate){
    initValidate()
  }
  const ajvValidationErrors = ajvValidate (powtoonForAjv)

  if (!powtoonValidationErrors) {
    return ajvValidationErrors
  }

  if (!ajvValidationErrors) {
    return powtoonValidationErrors
  }

  return {
    errors: [...powtoonValidationErrors.errors, ...ajvValidationErrors.errors],
    // eslint-disable-next-line max-len
    errorMessage: `POWTOON VALIDATION:\n-------------------\n\n${powtoonValidationErrors.errorMessage}\n\nSCHEMA VALIDATION:\n------------------\n\n${ajvValidationErrors.errorMessage}`
  }
}
export const updateSpriteRichTextColor = (slide) => {
  slide.tracks.forEach(track => {
    const {sprites: [sprite] = []} = track || {}

    if (sprite?.richText?.value) {
      applyFunctionOnAllLeafs(sprite.richText.value, (leaf) => {
        if (!leaf.color || !colord(leaf.color).isValid()) {
          leaf.color = DEFAULT_RICH_TEXT_COLOR
        }
        if (leaf.color && colord(leaf.color).isValid() && getFormat(leaf.color) !== 'hex') {
          leaf.color = colord(leaf.color).toHex()
        }
      })
    }
  })
}

export function updatePowtoonContent(content) {
  // update powtoon content designed in a way to be executed only 1 or 0 time in every powtoon lifecycle
  // it powtoon content version is >= specific function version - this function will never run
  // here we should add missing fields to the powtoon document
  // later steps :
  // validate : we detect the missing asset in manifest , find wrong data and types
  // recovery : will try to fix all that is broken or missing including the manifest
  // part of the recovery will replace and update manifest using api call with all  manifest ids form server
  //this time we will :
  // *  set missing values in the richtext color
  content.powtoon.slides.forEach(slide => {
    updateSpriteRichTextColor(slide)
  })
}
  
